export default __webpack_public_path__ + "static/media/Ginkgo_Bioworks_logo_white.dd9c1bf6.svg";